import { BadgeCheck, Sparkles } from "lucide-react";
import { CATEGORY_MAP, imgSrc } from "@/lib/categories";

export function FeaturedStrip({ items, city, onOpen }) {
  const featured = items.filter((l) => l.featured);
  if (!featured.length) return null;
  return (
    <section data-testid="featured-strip" className="mb-8">
      <h3 className="text-lg font-bold flex items-center gap-2 mb-3"><BadgeCheck className="h-4 w-4 text-[#FFB800]" /> Featured in {city}</h3>
      <div className="-mx-4 px-4 flex gap-3 overflow-x-auto no-scrollbar pb-2">
        {featured.map((l, i) => (
          <button key={l.id} type="button" data-testid={`featured-${l.id}`} onClick={() => onOpen(l)} style={{ animationDelay: `${i * 50}ms` }}
            className="rise group shrink-0 w-64 rounded-2xl overflow-hidden border border-[#FFB800]/60 bg-[#151C2C] text-left">
            <div className="relative h-32">
              {l.image_url ? <img src={imgSrc(l.image_url)} alt={l.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                : <div className="h-full w-full bg-gradient-to-br from-[#FFB800]/30 to-[#FF3B6B]/20" />}
              {l.is_new && <span data-testid={`featured-new-${l.id}`} className="absolute top-2 left-2 flex items-center gap-1 text-[11px] font-bold bg-[#00E5A3] text-[#0B0F19] px-2 py-0.5 rounded-full"><Sparkles className="h-3 w-3" /> New</span>}
            </div>
            <div className="p-3">
              <p className="font-semibold truncate">{l.name}</p>
              <p className="text-xs text-slate-400 truncate">{CATEGORY_MAP[l.category]?.label}{l.daily_update ? ` · ${l.daily_update}` : ""}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
